import React, { useState, useEffect } from 'react';
import { Card, Tabs } from 'antd';
import { SecurityScanOutlined, TeamOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import RoleManagement from './RoleManagement';
import PermissionMatrix from './PermissionMatrix';
import { setError } from '../reducers';

const { TabPane } = Tabs;

const RolesAndPermissions = ({ roles, loading }) => {
    const dispatch = useDispatch();
    const [activeKey, setActiveKey] = useState('roles');

    // Clear errors when component mounts
    useEffect(() => {
        dispatch(setError(null));
    }, [dispatch]);

    const handleTabChange = (key) => {
        // Clear errors when switching tabs
        dispatch(setError(null));
        setActiveKey(key);
    };

    return (
        <Card>
            <Tabs
                activeKey={activeKey}
                onChange={handleTabChange}
                type="line"
            >
                <TabPane
                    tab={
                        <span>
                            <TeamOutlined /> Quản lý Roles
                        </span>
                    }
                    key="roles"
                >
                    <RoleManagement
                        roles={roles}
                        loading={loading}
                    />
                </TabPane>

                <TabPane
                    tab={
                        <span>
                            <SafetyCertificateOutlined /> Ma trận phân quyền
                        </span>
                    }
                    key="permissions"
                >
                    <PermissionMatrix />
                </TabPane>
            </Tabs>
        </Card>
    );
};

export default RolesAndPermissions;
